<template>
  <span>
    <b-badge
      :id="popoverTarget"
      variant="light"
      class="lh-1 text-white cursor-default"
      :class="badgeClass"
      pill
    >
      <font-awesome-icon icon="code-branch" class="lh-1" size="sm" />
      {{ labelMessage }}
    </b-badge>

    <b-popover
      v-if="isValid"
      :target="popoverTarget"
      triggers="hover"
      :placement="placement"
      data-class="w-pannel-commit"
    >
      <template #title>
        <font-awesome-icon icon="code-branch" class="mr-1" size="sm" />
        <span
          class="h5 mb-0 title-popover text-exitos d-inline-flex"
          v-html="title"
        />
      </template>
      <dl class="mb-0">
        <dt>
          <h5 class="text-small text-exitos mb-0">Commit</h5>
        </dt>
        <dd class="mb-0">
          <p class="text-muted text-sm font-weight-normal" v-text="commit" />
        </dd>
        <dt>
          <h5 class="text-small text-exitos mb-0">Hash</h5>
        </dt>
        <dd class="mb-0">
          <p class="text-muted text-sm font-weight-normal" v-text="hash" />
        </dd>
        <dt>
          <h5 class="text-small text-exitos mb-0">Autor</h5>
        </dt>
        <dd class="mb-0">
          <p class="text-muted text-sm font-weight-normal" v-text="author" />
        </dd>
      </dl>
    </b-popover>
  </span>
</template>

<script>
import { useLastCommit } from "@/composables/useLastCommit";
import { randomId } from "@/helpers/functions/randomId";
import { computed, defineComponent } from "vue";

export default defineComponent({
  name: "BadgeCommit",
  props: {
    placement: {
      type: String,
      default: "top",
    },
  },
  setup() {
    const popoverTarget = randomId("popover-commit");
    const { $isHMG, $isValid, author, date, commit, hash } = useLastCommit();

    const labelMessage = computed(() => ($isHMG ? "HMG" : "Prod"));
    const badgeClass = computed(() =>
      $isHMG ? "bg-success-dark" : "bg-danger"
    );
    const title = computed(
      () =>
        `Último commit <span class="text-muted font-weight-600 ml-auto">${date}</span>`
    );

    return {
      author,
      badgeClass,
      commit,
      hash,
      isDev: $isHMG,
      isValid: $isValid,
      labelMessage,
      popoverTarget,
      title,
    };
  },
});
</script>

<style scoped lang="scss">
.lh-1 {
  line-height: 1;
}
</style>

<style lang="scss">
[data-class="w-pannel-commit"] {
  min-width: 350px;

  .popover-header {
    display: flex;
    align-items: center;
  }

  .title-popover {
    flex-grow: 1;
  }
}
</style>
